// Figma uses shorter copy on mobile than from tablet (md) up. Both are in the markup and CSS
// picks one, so nothing changes on hydration. Same string twice renders once.
export function ResponsiveText({ short, long }: { short: string; long: string }) {
  if (short === long) return <>{long}</>;

  return (
    <>
      <span className="md:hidden">{short}</span>
      <span className="hidden md:inline">{long}</span>
    </>
  );
}
